window.TV2.handlePromoClip = (entries) => {
  entries.forEach((entry) => {
    if (!entry.target.classList.contains('lazy-autoplay')) {
      if (entry.isIntersecting) {
        entry.target.play();
      } else {
        entry.target.pause();
      }
    }
  });
};

window.TV2.loadPromoClip = (entries, observer) => {
  entries.forEach((clip) => {
    if (clip.isIntersecting) {
      [...clip.target.children].forEach((source) => {
        const clipSource = source;
        if (typeof clipSource.tagName === 'string' && clipSource.tagName === 'SOURCE') {
          clipSource.src = clipSource.dataset.src;
        }
      });
      if (!clip.target.autoplay) {
        try {
          const posterUrl = new URL(clip.target.dataset.poster);
          clip.target.setAttribute('poster', posterUrl);
        } catch (e) {
          // attr data-poster is not a valid url - we will not set it as video poster attribute
        }
      }
      clip.target.load();
      clip.target.classList.remove('lazy-autoplay');
      observer.unobserve(clip.target);
    }
  });
};

document.addEventListener('DOMContentLoaded', function () {
  if ('IntersectionObserver' in window) {
    const promoclips = document.querySelectorAll('video.lazy-autoplay');
    const motionQuery = matchMedia('(prefers-reduced-motion)');
    [...promoclips].forEach((clip) => {
      const theClip = clip;
      if (motionQuery.matches) {
        theClip.autoplay = false;
        theClip.addEventListener('click', (e) => {
          theClip.paused ? theClip.play() : theClip.pause();
        });
      }
      if (theClip.classList.contains('lazy-autoplay')) {
        TV2.createObserver(theClip, TV2.loadPromoClip, {
          rootMargin: `0px 0px`,
          threshold: [0.0],
        });
      }

      if (theClip.dataset.trigger === 'hover') {
        theClip.addEventListener('mouseover', (e) => {
          e.target.play();
        });
        theClip.addEventListener('mouseout', (e) => {
          e.target.pause();
        });
      }
    });
  }
});
